<template>
  <div :class="prefixCls">
    <Row :gutter="20" justify="center" align="middle">
      <Col
        span="6"
        v-for="(item, index) in tabLists"
        :key="index"
        class="tab-item"
        :class="activeIndex === index+1 ? ['animated','fast', 'slideInDown'] : ''"
      >
        <span @click="activeChange(index + 1)">{{item}}</span>
      </Col>
    </Row>
  </div>
</template>
<script>
const prefixCls = "zTabs";
export default {
  name: "ZTabs",
  data() {
    return {
      prefixCls: prefixCls,
    };
  },
  model: {
    props: "indexVal",
    event: "changeTabsHandle"
  },
  props: {
    tabLists: {
      type: Array,
      default: function() {
        return [];
      }
    },
    activeIndex: {
      type: [Number, String],
      default: 1
    },
    indexVal: {
      type: [Number, String],
      default: 1
    }
  },
  methods: {
    activeChange(index) {
      this.$emit("changeTabsHandle", index);
    }
  }
};
</script>

